import z from 'zod';

export const passwordSchema = z
  .string('Campo obrigatório!')
  .min(8, 'A senha deve ter no mínimo 8 caracteres!')
  .regex(/[a-z]/, 'Deve conter pelo menos uma letra minúscula!')
  .regex(/[0-9]/, 'Deve conter pelo menos um número!');

export const authSchemas = {
  signUp: z.object({
    name: z.string('Campo obrigatório!').min(1, 'Campo obrigatório!'),
    email: z.email('E-mail inválido!'),
    password: passwordSchema,
    rememberMe: z.boolean().optional(),
  }),
  signIn: z.object({
    email: z.email('E-mail inválido!'),
    password: passwordSchema,
    rememberMe: z.boolean().optional().default(true),
  }),
  updateProfile: z.object({
    name: z.string('Campo obrigatório!').min(1, 'Campo obrigatório!').optional(),
    image: z.string('Campo obrigatório!').optional(),
  }),
  // Self-service (perfil): exige a senha atual, valida de verdade via better-auth.
  changePassword: z.object({
    currentPassword: z.string('Campo obrigatório!').min(1, 'Campo obrigatório!'),
    newPassword: passwordSchema,
  }),
  // Troca forçada após reset de senha pelo admin: sem senha atual (era uma temporária),
  // só libera se o usuário logado estiver com a flag `needToChangePassword` ligada.
  forceChangePassword: z.object({
    newPassword: passwordSchema,
  }),
};

export type SignUpSchema = z.infer<typeof authSchemas.signUp>;
export type SignInSchema = z.input<typeof authSchemas.signIn>;
export type UpdateProfileSchema = z.infer<typeof authSchemas.updateProfile>;
export type ChangePasswordSchema = z.infer<typeof authSchemas.changePassword>;
export type ForceChangePasswordSchema = z.infer<typeof authSchemas.forceChangePassword>;
